export const LOAD_APPLICATION_FEATURES_STARTED = "LOAD_APPLICATION_FEATURES_STARTED";
export const LOAD_APPLICATION_FEATURES_SUCCESS = "LOAD_APPLICATION_FEATURES_SUCCESS";
